export default __webpack_public_path__ + "static/media/10.1297cf7b.png";